import React, { useState, useEffect } from 'react';
import { CTA } from '@volkswagen-onehub/components-core';
import { CarlineBase } from 'src/types';
import { HistoryServiceV2 } from '@feature-hub/history-service';
import { OfferCarlineCardProps } from '.';
import { useFeatureServices } from 'src/feature-app/hooks';

const getHrefAnchor = (carline: CarlineBase, historyService: HistoryServiceV2) => {
  if (historyService?.rootHistory?.location?.pathname) {
    const splittedPathname = historyService.rootHistory.location.pathname.split('/');
    const idx = splittedPathname.findIndex((a) => a.includes('ofertas'));
    const finalString = splittedPathname.slice(0, idx + 1).join('/');
    return `${finalString}/__app/${carline.name}.app`;
  } else {
    return '';
  }
};

export const ShowOffersCTA = (props: OfferCarlineCardProps) => {

  const { carline } = props;
  const [numberOfOffers, setNumberOfOffers] = useState(props.carline.ofertas.length);
  const historyService = useFeatureServices()['s2:history'];

  const getCtaText = (numberOfOffers: number) => {
    return numberOfOffers === 1 ? 'Ver la oferta' : `Ver las ${numberOfOffers} ofertas`;
  };

  useEffect(() => {
    const lastOffer = carline.ofertas[carline.ofertas.length - 1];

    if (props.carline.activoOcasion === 1 && !lastOffer.ocasion) {
      setNumberOfOffers(numberOfOffers + 1);
    }
  }, []);

  return (
    <CTA
      tag="a"
      emphasis="secondary"
      onClick={(e) => {
        e.preventDefault();
      }}
      href={getHrefAnchor(carline, historyService)}
    >
      {getCtaText(numberOfOffers)}
    </CTA>
  );
};
